<template>
    <div class="news-and-press-item grid grid__base" :class="rootClasses">
        <!-- <pre v-if="article" v-text="article"></pre> -->

        <div class="grid--row news-and-press-item--row">
            <div class="grid--col news-and-press-item--type">
                <span class="news-and-press-item--type-label"
                        v-text="articleTypeLabel">
                </span>
            </div>
            <div class="grid--col news-and-press-item--img">
                <div class="news-and-press-item--img-inner">
                    <img class="news-and-press-item--img-el" v-if="imageData.src" v-bind="imageData">
                    <div class="news-and-press-item--img-placeholder" v-else></div>
                </div>
            </div>
            <div class="grid--col news-and-press-item--data">
                <div class="news-and-press-item--data-inner">
                    <time class="news-and-press-item--time" v-text="article.publication_date"></time>
                    <h2 class="news-and-press-item--title" v-text="article.title"></h2>
                    <div class="news-and-press-item--lead" v-html="article.lead"></div>

                    <div class="grid--row news-and-press-item--btn-row" v-if="article.link">
                        <div class="grid--col news-and-press-item--btn-col">
                            <cmp-rich-button :plugin="article.link"></cmp-rich-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import { mapFilters } from 'util/vue/map-filters';


    export default {
        mixins: [
            bemMixin('news-and-press-item'),
        ],
        props: {
            article: Object,
            articleTypeLabel: String,
        },
        computed: {
            rootClasses() {
                return [
                    this.bemAdd(this.article.article_type),
                ];
            },
            imageData() {
                const image = this.article.image || {};

                return {
                    src: image.url,
                    alt: image.alt,
                };
            },
        },
        methods: {
            ...mapFilters(['static']),
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?04486e94